<template>
  <section v-if="productsLeft?.length > 0" class="promo-banner">
    <div class="promo-banner__content">
      <div class="promo-badge">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>Discover More</span>
      </div>
      
      <div class="promo-slider">
        <div class="promo-slider__track" ref="sliderContainter">
          <div
            v-for="feature in productsLeft"
            :key="feature._id"
            class="promo-slide"
          >
            <div class="promo-slide__text">
              <div class="promo-slide__icon">
                <svg v-if="feature.category === 'INVEST' || feature.name?.toLowerCase().includes('invest') || feature.name?.toLowerCase().includes('treasury')" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M23 6L13.5 15.5L8.5 10.5L1 18" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M17 6H23V12" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <svg v-else-if="feature.category === 'PUBLIC_RAISE' || feature.name?.toLowerCase().includes('public')" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="10" stroke="#ffffff" stroke-width="2"/>
                  <path d="M2 12H22" stroke="#ffffff" stroke-width="2"/>
                  <path d="M12 2C14.5013 4.73835 15.9228 8.29203 16 12C15.9228 15.708 14.5013 19.2616 12 22C9.49872 19.2616 8.07725 15.708 8 12C8.07725 8.29203 9.49872 4.73835 12 2Z" stroke="#ffffff" stroke-width="2"/>
                </svg>
                <svg v-else-if="feature.category === 'PRIVATE_RAISE' || feature.name?.toLowerCase().includes('private')" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#ffffff" stroke-width="2"/>
                  <path d="M9 12L11 14L15 10" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <svg v-else-if="feature.category === 'ESOP' || feature.name?.toLowerCase().includes('employee') || feature.name?.toLowerCase().includes('esop')" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <circle cx="9" cy="7" r="4" stroke="#ffffff" stroke-width="2"/>
                  <path d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <svg v-else-if="feature.category === 'CREDIT' || feature.name?.toLowerCase().includes('credit') || feature.name?.toLowerCase().includes('loan')" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect x="1" y="4" width="22" height="16" rx="2" stroke="#ffffff" stroke-width="2"/>
                  <path d="M1 10H23" stroke="#ffffff" stroke-width="2"/>
                </svg>
                <svg v-else-if="feature.category === 'API_KEY' || feature.name?.toLowerCase().includes('api')" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M16 18L22 12L16 6" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M8 6L2 12L8 18" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M21 16V8C20.9996 7.6493 20.9071 7.30483 20.7315 7.00017C20.556 6.69552 20.3037 6.44149 20 6.26L13 2.26C12.696 2.08968 12.3511 2 12 2C11.6489 2 11.304 2.08968 11 2.26L4 6.26C3.69626 6.44149 3.44398 6.69552 3.26846 7.00017C3.09294 7.30483 3.00036 7.6493 3 8V16C3.00036 16.3507 3.09294 16.6952 3.26846 16.9998C3.44398 17.3045 3.69626 17.5585 4 17.74L11 21.74C11.304 21.9103 11.6489 22 12 22C12.3511 22 12.696 21.9103 13 21.74L20 17.74C20.3037 17.5585 20.556 17.3045 20.7315 16.9998C20.9071 16.6952 20.9996 16.3507 21 16Z" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <h3 class="promo-slide__title">{{ feature.name }}</h3>
              <p class="promo-slide__description">{{ feature.description }}</p>
              <button class="promo-slide__btn" @click="showInfo(feature)">
                Learn More
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
            
            <!-- Feature-specific illustration -->
            <div class="promo-slide__illustration">
              <!-- INVEST / Treasury illustration - Growth chart -->
              <svg v-if="feature.category === 'INVEST' || feature.name?.toLowerCase().includes('invest') || feature.name?.toLowerCase().includes('treasury')" viewBox="0 0 200 200" fill="none">
                <circle cx="100" cy="100" r="80" stroke="rgba(77, 132, 255, 0.2)" stroke-width="1"/>
                <circle cx="100" cy="100" r="60" stroke="rgba(77, 132, 255, 0.15)" stroke-width="1"/>
                <path d="M40 140 L70 110 L100 125 L130 80 L160 60" stroke="#4D84FF" stroke-width="3" stroke-linecap="round" fill="none"/>
                <path d="M40 140 L70 110 L100 125 L130 80 L160 60 L160 160 L40 160 Z" fill="url(#investGrad)" opacity="0.3"/>
                <circle cx="70" cy="110" r="5" fill="#4D84FF"/>
                <circle cx="100" cy="125" r="5" fill="#4D84FF"/>
                <circle cx="130" cy="80" r="5" fill="#4D84FF"/>
                <circle cx="160" cy="60" r="7" fill="#4D84FF"/>
                <rect x="130" y="100" width="50" height="35" rx="6" fill="rgba(255,255,255,0.1)" stroke="rgba(255,255,255,0.2)"/>
                <text x="145" y="122" fill="#ffffff" font-size="14" font-weight="500">+24%</text>
                <defs>
                  <linearGradient id="investGrad" x1="100" y1="60" x2="100" y2="160" gradientUnits="userSpaceOnUse">
                    <stop offset="0%" stop-color="#4D84FF"/>
                    <stop offset="100%" stop-color="#4D84FF" stop-opacity="0"/>
                  </linearGradient>
                </defs>
              </svg>
              
              <!-- PUBLIC_RAISE illustration - Globe with connections -->
              <svg v-else-if="feature.category === 'PUBLIC_RAISE' || feature.name?.toLowerCase().includes('public')" viewBox="0 0 200 200" fill="none">
                <circle cx="100" cy="100" r="70" stroke="rgba(77, 132, 255, 0.3)" stroke-width="2"/>
                <ellipse cx="100" cy="100" rx="70" ry="30" stroke="rgba(77, 132, 255, 0.2)" stroke-width="1"/>
                <ellipse cx="100" cy="100" rx="30" ry="70" stroke="rgba(77, 132, 255, 0.2)" stroke-width="1"/>
                <path d="M30 100 H170" stroke="rgba(77, 132, 255, 0.15)" stroke-width="1"/>
                <path d="M100 30 V170" stroke="rgba(77, 132, 255, 0.15)" stroke-width="1"/>
                <circle cx="60" cy="70" r="12" fill="rgba(77, 132, 255, 0.3)" stroke="#4D84FF" stroke-width="2"/>
                <circle cx="140" cy="80" r="10" fill="rgba(77, 132, 255, 0.3)" stroke="#4D84FF" stroke-width="2"/>
                <circle cx="80" cy="130" r="8" fill="rgba(77, 132, 255, 0.3)" stroke="#4D84FF" stroke-width="2"/>
                <circle cx="150" cy="120" r="14" fill="rgba(77, 132, 255, 0.3)" stroke="#4D84FF" stroke-width="2"/>
                <path d="M60 70 L140 80" stroke="rgba(255,255,255,0.3)" stroke-width="1" stroke-dasharray="4 4"/>
                <path d="M140 80 L150 120" stroke="rgba(255,255,255,0.3)" stroke-width="1" stroke-dasharray="4 4"/>
                <path d="M80 130 L150 120" stroke="rgba(255,255,255,0.3)" stroke-width="1" stroke-dasharray="4 4"/>
              </svg>
              
              <!-- PRIVATE_RAISE illustration - Shield with checkmark -->
              <svg v-else-if="feature.category === 'PRIVATE_RAISE' || feature.name?.toLowerCase().includes('private')" viewBox="0 0 200 200" fill="none">
                <path d="M100 20 L160 50 V110 C160 145 135 175 100 185 C65 175 40 145 40 110 V50 L100 20Z" stroke="rgba(77, 132, 255, 0.3)" stroke-width="2" fill="rgba(77, 132, 255, 0.1)"/>
                <path d="M100 40 L145 62 V105 C145 132 125 155 100 163 C75 155 55 132 55 105 V62 L100 40Z" stroke="rgba(77, 132, 255, 0.2)" stroke-width="1" fill="none"/>
                <path d="M75 100 L92 117 L125 84" stroke="#4D84FF" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
                <circle cx="100" cy="100" r="35" stroke="rgba(77, 132, 255, 0.2)" stroke-width="1" fill="none"/>
              </svg>
              
              <!-- ESOP illustration - People network -->
              <svg v-else-if="feature.category === 'ESOP' || feature.name?.toLowerCase().includes('employee') || feature.name?.toLowerCase().includes('esop')" viewBox="0 0 200 200" fill="none">
                <circle cx="100" cy="60" r="25" stroke="#4D84FF" stroke-width="2" fill="rgba(77, 132, 255, 0.2)"/>
                <circle cx="100" cy="50" r="12" stroke="#ffffff" stroke-width="2" fill="none"/>
                <path d="M80 75 Q100 95 120 75" stroke="#ffffff" stroke-width="2" fill="none"/>
                <circle cx="50" cy="130" r="20" stroke="rgba(77, 132, 255, 0.5)" stroke-width="2" fill="rgba(77, 132, 255, 0.1)"/>
                <circle cx="50" cy="122" r="8" stroke="rgba(255,255,255,0.6)" stroke-width="1.5" fill="none"/>
                <path d="M38 138 Q50 150 62 138" stroke="rgba(255,255,255,0.6)" stroke-width="1.5" fill="none"/>
                <circle cx="150" cy="130" r="20" stroke="rgba(77, 132, 255, 0.5)" stroke-width="2" fill="rgba(77, 132, 255, 0.1)"/>
                <circle cx="150" cy="122" r="8" stroke="rgba(255,255,255,0.6)" stroke-width="1.5" fill="none"/>
                <path d="M138 138 Q150 150 162 138" stroke="rgba(255,255,255,0.6)" stroke-width="1.5" fill="none"/>
                <path d="M75 75 L55 110" stroke="rgba(77, 132, 255, 0.4)" stroke-width="2" stroke-dasharray="4 4"/>
                <path d="M125 75 L145 110" stroke="rgba(77, 132, 255, 0.4)" stroke-width="2" stroke-dasharray="4 4"/>
                <path d="M70 130 L130 130" stroke="rgba(77, 132, 255, 0.3)" stroke-width="1" stroke-dasharray="4 4"/>
                <rect x="75" y="150" width="50" height="25" rx="5" fill="rgba(77, 132, 255, 0.2)" stroke="rgba(77, 132, 255, 0.4)"/>
                <text x="85" y="167" fill="#ffffff" font-size="10" font-weight="500">ESOP</text>
              </svg>
              
              <!-- CREDIT illustration - Card with coins -->
              <svg v-else-if="feature.category === 'CREDIT' || feature.name?.toLowerCase().includes('credit') || feature.name?.toLowerCase().includes('loan')" viewBox="0 0 200 200" fill="none">
                <rect x="30" y="60" width="120" height="80" rx="10" stroke="#4D84FF" stroke-width="2" fill="rgba(77, 132, 255, 0.15)"/>
                <path d="M30 85 H150" stroke="rgba(77, 132, 255, 0.5)" stroke-width="2"/>
                <rect x="45" y="105" width="40" height="8" rx="4" fill="rgba(255,255,255,0.3)"/>
                <rect x="45" y="120" width="25" height="6" rx="3" fill="rgba(255,255,255,0.2)"/>
                <circle cx="140" cy="140" r="30" stroke="rgba(77, 132, 255, 0.3)" stroke-width="2" fill="rgba(77, 132, 255, 0.1)"/>
                <circle cx="140" cy="140" r="20" stroke="rgba(77, 132, 255, 0.2)" stroke-width="1" fill="none"/>
                <text x="132" y="147" fill="#4D84FF" font-size="18" font-weight="600">$</text>
                <circle cx="160" cy="100" r="15" stroke="rgba(77, 132, 255, 0.4)" stroke-width="1" fill="rgba(77, 132, 255, 0.1)"/>
                <text x="154" y="106" fill="rgba(255,255,255,0.6)" font-size="12" font-weight="500">%</text>
              </svg>
              
              <!-- API illustration - Code brackets -->
              <svg v-else-if="feature.category === 'API_KEY' || feature.name?.toLowerCase().includes('api')" viewBox="0 0 200 200" fill="none">
                <rect x="30" y="40" width="140" height="120" rx="10" stroke="rgba(77, 132, 255, 0.3)" stroke-width="2" fill="rgba(77, 132, 255, 0.1)"/>
                <rect x="30" y="40" width="140" height="25" rx="10" fill="rgba(77, 132, 255, 0.2)"/>
                <circle cx="48" cy="52" r="5" fill="#EF4444"/>
                <circle cx="65" cy="52" r="5" fill="#F59E0B"/>
                <circle cx="82" cy="52" r="5" fill="#10B981"/>
                <path d="M70 100 L50 120 L70 140" stroke="#4D84FF" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
                <path d="M130 100 L150 120 L130 140" stroke="#4D84FF" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
                <path d="M110 90 L90 150" stroke="rgba(255,255,255,0.4)" stroke-width="2" stroke-linecap="round"/>
                <rect x="80" y="75" width="40" height="8" rx="4" fill="rgba(255,255,255,0.2)"/>
              </svg>
              
              <!-- Default illustration - Abstract shapes -->
              <svg v-else viewBox="0 0 200 200" fill="none">
                <circle cx="100" cy="100" r="70" stroke="rgba(77, 132, 255, 0.2)" stroke-width="1"/>
                <circle cx="100" cy="100" r="50" stroke="rgba(77, 132, 255, 0.15)" stroke-width="1"/>
                <circle cx="100" cy="100" r="30" fill="rgba(77, 132, 255, 0.1)"/>
                <rect x="70" y="70" width="60" height="60" rx="10" stroke="#4D84FF" stroke-width="2" fill="rgba(77, 132, 255, 0.2)" transform="rotate(15 100 100)"/>
                <path d="M85 100 L95 110 L115 90" stroke="#ffffff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
      
      <div v-if="productsLeft.length > 1" class="promo-nav">
        <button 
          class="promo-nav__arrow" 
          @click="--currentPosition"
          :disabled="currentPosition === 0"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <div class="promo-nav__dots">
          <button
            v-for="(feature, index) in productsLeft"
            :key="'dot-' + feature._id"
            @click="currentPosition = index"
            class="promo-nav__dot"
            :class="{ 'promo-nav__dot--active': currentPosition === index }"
          ></button>
        </div>
        <button 
          class="promo-nav__arrow" 
          @click="currentPosition++"
          :disabled="currentPosition === productsLeft.length - 1"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>
    
    <Teleport to="#teleport-modal">
      <ProductsModal
        v-if="showProductModal"
        :show="showProductModal"
        :product="product"
        @subscribe-to-service="subscribeToService"
        @close-api-modal="showProductModal = false"
      />
    </Teleport>
  </section>
</template>

<script>
  import ProductsModal from "@/components/overview/ProductsModal";
  import { mapActions, mapGetters } from "vuex";
  export default {
    name: "ProductsBanner",
    data() {
      return {
        showProductModal: false,
        product: {},
        currentPosition: 0,
      };
    },
    components: {
      ProductsModal,
    },
    created() {
      console.log(this.features, "features")
    },
    computed: {
      ...mapGetters("organisationModule", ["features", "organisationDetails"]),
      productsLeft() {
        return this.features?.filter(
          (feature) =>
            !this.organisationDetails.products.includes(feature.category) &&
            feature.status === "ACTIVE"
        );
      },
    },
    watch: {
      currentPosition(val) {
        const sliderContainer = this.$refs.sliderContainter;
        if (sliderContainer) {
          const translatePosition = val * 100;
          sliderContainer.style.transform = `translateX(-${translatePosition}%)`;
        }
      },
    },
    methods: {
      ...mapActions(["showToast"]),
      ...mapActions("organisationModule", [
        "subscribeToFeature",
        "getFeatures",
      ]),
      async subscribeToService(product) {
        try {
          const response = await this.subscribeToFeature([product]);
          this.showProductModal = false;
          const { message } = response.data;
          this.showToast({
            description: message,
            display: true,
            type: "success",
          });
          this.navigateToPage(product);
          this.getFeatures();
        } catch (error) {
          return error;
        }
      },
      navigateToPage(product) {
        let routeName = null;
        switch (product) {
          case "INVEST":
            routeName = "Invest";
            break;
          case "PUBLIC_RAISE":
            routeName = "PublicRaise";
            break;
          case "PRIVATE_RAISE":
            routeName = "PrivateRaise";
            break;
          case "ESOP":
            routeName = "EmployeeBenefits";
            break;
        }
        setTimeout(() => {
          this.$router.push({ name: routeName });
        }, 1500);
      },
      showInfo(feature) {
        this.product = feature;
        this.showProductModal = true;
      },
    },
  };
</script>

<style lang="scss" scoped>
.promo-banner {
  background: #0F172A;
  border-radius: 12px;
  overflow: hidden;
  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  position: relative;
  min-height: 240px;
}

.promo-banner__content {
  padding: 28px 32px;
  position: relative;
  z-index: 1;
  
  @media (max-width: 768px) {
    padding: 24px;
  }
}

.promo-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: rgba(77, 132, 255, 0.15);
  border-radius: 20px;
  color: #4D84FF;
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 20px;
}

.promo-slider {
  overflow: hidden;
  margin-bottom: 20px;
}

.promo-slider__track {
  display: flex;
  transition: transform 0.4s ease;
}

.promo-slide {
  min-width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  
  @media (max-width: 768px) {
    flex-direction: column-reverse;
    gap: 16px;
  }
  
  &__text {
    flex: 1;
    max-width: 420px;
    
    @media (max-width: 768px) {
      max-width: 100%;
    }
  }
  
  &__icon {
    width: 44px;
    height: 44px;
    background: rgba(77, 132, 255, 0.2);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    margin-bottom: 14px;
  }
  
  &__title {
    font-size: 20px;
    font-weight: 500;
    color: #ffffff;
    margin-bottom: 8px;
  }
  
  &__description {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    line-height: 1.6;
    margin-bottom: 18px;
  }
  
  &__btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 11px 18px;
    background: #ffffff;
    color: #0F172A;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
      background: #F1F5F9;
      
      svg {
        transform: translateX(4px);
      }
    }
    
    svg {
      transition: transform 0.2s ease;
    }
  }
  
  &__illustration {
    flex-shrink: 0;
    width: 180px;
    height: 180px;
    
    @media (max-width: 768px) {
      width: 140px;
      height: 140px;
    }
    
    svg {
      width: 100%;
      height: 100%;
    }
  }
}

.promo-nav {
  display: flex;
  align-items: center;
  gap: 16px;
  
  &__arrow {
    width: 36px;
    height: 36px;
    background: rgba(255, 255, 255, 0.1);
    border: none;
    border-radius: 8px;
    color: #ffffff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    
    &:hover:not(:disabled) {
      background: rgba(255, 255, 255, 0.2);
    }
    
    &:disabled {
      opacity: 0.3;
      cursor: not-allowed;
    }
  }
  
  &__dots {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  &__dot {
    width: 8px;
    height: 8px;
    background: rgba(255, 255, 255, 0.3);
    border: none;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
      background: rgba(255, 255, 255, 0.5);
    }
    
    &--active {
      background: #4D84FF;
      width: 24px;
      border-radius: 4px;
    }
  }
}
</style>
